import { render, staticRenderFns } from "./CkeditorWrapper.vue?vue&type=template&id=9b81ad78&"
import script from "./CkeditorWrapper.vue?vue&type=script&lang=js&"
export * from "./CkeditorWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b81ad78')) {
      api.createRecord('9b81ad78', component.options)
    } else {
      api.reload('9b81ad78', component.options)
    }
    module.hot.accept("./CkeditorWrapper.vue?vue&type=template&id=9b81ad78&", function () {
      api.rerender('9b81ad78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/CkeditorWrapper.vue"
export default component.exports